import type { DisputeNote } from "@/types/dispute-note";

/**
 * Mock dispute notes data for demo mode
 */
export const mockDisputeNotes: Record<string, DisputeNote[]> = {};

/**
 * Get notes for a specific dispute
 */
export function getDisputeNotes(disputeId: string): DisputeNote[] {
  return mockDisputeNotes[disputeId] || [];
}
